import SelectionState from "state/selections/SelectionState";
import SummaryType from "state/selections/Constants/SummaryType";
import { titleCase } from "@ls/js-utils";
import { selectDefinitions, selectFetchingData } from "./selectors";
import { useDispatch, useSelector } from "react-redux";
import React from "react";
import { deleteColumn } from "state/grid/actions";

export const useColumnDefinitions = () => {
  const definitions = useSelector(selectDefinitions(SelectionState.COMMITTED));
  const fetchingAbsData = useSelector(selectFetchingData(SummaryType.ABSOLUTE));
  const fetchingRelData = useSelector(selectFetchingData(SummaryType.RELATIVE));
  const dispatch = useDispatch();
  return React.useMemo(() => {
    return definitions.reduce((colDefs, definition) => {
      const { percentiles, scan2CalcType, summary } = definition;
      colDefs.push({
        X_onDelete: () => dispatch(deleteColumn(definition)),
        headerName: `VaR ${titleCase(scan2CalcType)} ${(
          percentiles
        )} % ${titleCase(summary)}`,
        field: `scan2 - ${scan2CalcType}, ${percentiles.toFixed()}, ${summary}`,
        colId: `scan2 - ${scan2CalcType}, ${percentiles}, ${summary}`,
        loading:
          (summary === SummaryType.ABSOLUTE && fetchingAbsData) ||
          (summary === SummaryType.RELATIVE && fetchingRelData),
      });
      return colDefs;
    }, []);
  }, [definitions, dispatch, fetchingAbsData, fetchingRelData]);
};
